'use client'

import React from "react";
import Link from "next/link";

const BlogCard = ({ blog }) => {
  const truncateHtml = (html, wordLimit) => {
    // Create a temporary DOM element to extract text
    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;
    const textContent = tempElement.textContent || tempElement.innerText || "";

    // Truncate the text content
    const truncatedText = textContent.split(" ").slice(0, wordLimit).join(" ") + "...";

    return truncatedText;
  };

  const truncatedDescription = truncateHtml(blog.description, 11);

  const cardStyles = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%", // Ensure all cards have equal height
  };

  return (
    <div
      className="relative flex w-80 flex-col rounded-xl bg-white bg-clip-border text-gray-700 shadow-md"
      style={cardStyles} // Inline style to ensure consistent height
    >
      <div className="relative mx-4 -mt-6 h-40 overflow-hidden rounded-xl bg-blue-gray-500 bg-clip-border text-white shadow-lg shadow-blue-gray-500/40 bg-gradient-to-r from-[#DB2777] to-[#DB2777]">
        <img src={blog.photo_url} alt={blog.title} />
      </div>
      <div className="p-6">
        <h5 className="mb-2 block font-sans text-xl font-semibold leading-snug tracking-normal text-[#DB2777] antialiased">
          {blog.title}
        </h5>
        <p className="block font-sans text-base font-light leading-relaxed text-inherit antialiased">
          <div dangerouslySetInnerHTML={{ __html: truncatedDescription }} />
        </p>
      </div>
      <div className="p-6 pt-0 flex justify-center">
  <Link href={`/blog/${blog.slug}`}>
    <button
      data-ripple-light="true"
      type="button"
      className="select-none rounded-md bg-[#DB2777] py-3 px-6 text-center align-middle font-sans text-xs font-bold uppercase text-white shadow-md shadow-[#DB2777]/20 transition-all hover:shadow-lg hover:shadow-[#DB2777]/40 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
      style={{ borderRadius: '0.375rem', color: 'white' }} // 0.375rem = rounded-md
    >
      <b>Read More</b>
    </button>
  </Link>
</div>
    </div>
  );
};

export default BlogCard;
